export default {
  curlan:'zh-EN',
  common: {
    sotck_hk: "Hong kong stock",
    sotck_us: "U.S. stock",
    sotck_A: "A Share",
    free: "Free of charge",
    tips1: "Save failed",
    unopen: 'No account opened',
  },
  tuyere: {
    title: "Popular stock list",
    nodata: "No data",
    down_refresh: {
      contentdown: "pull down refresh",
      contentover: "release refresh",
      contentrefresh: "loading...",
      contentsuccess: "refresh succeeded",
      contenterror: "refresh failed",
    },
    head: {
      txt_1: "Stock name",
      txt_2: "Current price",
      txt_3: "YTD Percentage Change",
    },
    concept: {
      txt_1: "Fold",
      txt_2: "There are {num} companies. Click to view all",
    },
    foot_1:
      "Risk warning: the above data are from third-party data sources and are for reference only. They do not constitute investment suggestions.",
    foot_2: "The market data service is provided by Meta Securities",
    foot_3: "Disclaimer",
  },
  my_market: {
    title: "My Quotes",
    active: 'Current permissions',
    buy: 'Buy',
    renew: 'Renewal',
    lv1: {
      txt_1: "Delay quotation",
      txt_2: "Manually refresh real-time quotes",
      txt_2_1: "The quotation data (quotation, time sharing, K-line, etc.) is delayed for 15 minutes, and there are no brokerage seats, order book and  trade details.",
      txt_3: "No handicap data",
      txt_4: "Free of charge",
      txt_5: "LV1 Basic market price",
    },
    lv2: {
      txt_1: "LV2 Real-time quotes",
      txt_2: "Real time updates",
      txt_3: "Lv1 handicap",
      txt_4: "Lv10 broker queue",
      txt_5: "Remaining {day} days",
      txt_6: "Get it for free",
      txt_7: "Offer trading handicap at LV1",
      txt_8: "Real-time",
      txt_9: "Offer real-time data of trading handicap at Lv5",
      txt_10: "Real-time market data",
      txt_11: "{money} HKD/Month",
      txt_12: 'Member gift',
    },
    warn_title:`Tips`,
      warn_desc:`1. Ordinary VIP will get 30 days L2 Quotes for free;<br/>
      2. Silver, gold, platinum, diamond VIP, members <br/>will always be free L2 quotes during the membership period;`
  },
  intro_quota:{
    title: "My Quotes",
    text_1:'Automatic updates',
    text_2:'5 Levels',
    text_3:'Update automaticly',
    text_4:'Free',
    text_5:'Manual updates',
    text_6:'10 Levels',
    text_7:'10-40 Levels',
    text_8:'Limit to 20',
    text_10:'Long-term effectiveness',
    text_11:'Depending  on the<br/> time of purchase',
    text_12:'13HKD/month',
    text_13:'200HKD/month',
    text_14:'400HKD/month<br/>(including PC)',
    text_15:'2.99USD/month',
    text_16:'Delay 15 minutes',
    text_17:'Delay Update',
    text_18:'*Note: BMP market has been offline.',
    hk:{
      text_1:'HK market LV2 Quotes',
      text_2:`Real time updates/10 Levels handicap/<br/>
      10 Levels brokerage queues`,
      text_3:'BMP VS LV2',
      table_txt1:'Delay quotation',
      table_txt2:'LV2',
      table_col1_txt1:'Real-time<br/> data',
      table_col1_txt2:'push',
      table_col1_txt3:'Handicap<br/> data',
      table_col1_txt4:'Tick',
      table_col1_txt5:'Brokerage seats',
      table_col1_txt6:'Quotes list',
      table_col1_txt7:'Domestic pricing',
      table_col1_txt8:'Overseas pricing',
      table_col1_txt9:'App+pc',
      table_col1_txt10:'Expiration date',      
      text_4:'Order details',
      text_5:'Accurately reflect intraday trading movements and gain insight into the intention of capital inflows and outflows',
      text_6:'10 Levels orders',
      text_7:'Grasp the support and resistance level of the stock price, accurately place orders to improve the transaction rate',
      text_8:'Order brokers',
      text_9:`See the Broker'sdisk control behavior and the number of pending orders`,
    },
    us:{
      text_1:'US market LV2 Quotes ',
      text_2:`Real-time Quotes/Real time updates/ <br/>
      Offer 1 level best bid and ask`,
      text_3:'LV1  VS LV2',
      table_txt1:'LV1',
      table_txt2:'LV2',
      table_col1_txt1:'Real-time<br/> data',
      table_col1_txt2:'Real-time<br/> push',
      table_col1_txt3:'Handicap<br/> data',
      table_col1_txt4:'Tick',
      table_col1_txt5:'Brokerage seats',
      table_col1_txt6:'Quotes list',
      table_col1_txt7:'Pricing',
      table_col1_txt8:'App+pc',
      table_col1_txt9:'Expiration date',
      text_4:'Order details',
      text_5:'Accurately reflect intraday trading movements and gain insight into the intention of capital inflows and outflows',
      text_6:'1 Levels orders',
      text_7:'Grasp the support and resistance level of the stock price, accurately place orders to improve the transaction rate',
      text_8:'Order brokers',
      text_9:`See the Broker'sdisk control behavior and the number of pending orders`,
    },
    cn:{
      text_1:'A share L1 Quotes',
      text_2:'Real-time Quotes/<br/>Offer 5 levels best bid and ask',
      text_3:'A share Quotes description',
      table_txt1:'LV1',
      table_col1_txt1:'Real-time<br/> data',
      table_col1_txt2:'Real-time<br/> push',
      table_col1_txt3:'Handicap<br/> data',
      table_col1_txt4:'Tick',
      table_col1_txt5:'Brokerage seats',
      table_col1_txt6:'Quotes list',
      table_col1_txt7:'Pricing',
      table_col1_txt8:'App+pc',
      text_4:'Order details',
      text_5:'Accurately reflect intraday trading movements and gain insight into the intention of capital inflows and outflows',
      text_6:'5 Levels orders',
      text_7:'Grasp the support and resistance level of the stock price, accurately place orders to improve the transaction rate',
      text_8:'Order brokers',
      text_9:`See the Broker'sdisk control behavior and the number of pending orders`,
    },

  },
  how_to_invest_old: {
    title: "Why do we invest in Hong Kong stocks and U.S. stocks",
    name1: "Invest global top listed companies in Hong Kong and U.S.",
    desc1: {
      text_1: "Transparent market",
      text_2:
        "Transparent rules and regulations of Hong Kong stocks and U.S. stocks",
      text_3: "More powerful guarantee on rights and benefits of investors",
    },
    desc2: {
      text_1: "T+0 trading",
      text_2: "Trading within a day, allowing flexible operation",
    },
    desc3: {
      text_1: "No limit on funds",
      text_2: "No requirement on 5 billion funds",
    },
    desc4: {
      text_1: "Rich targets",
      text_2: "Stock, ETF, funds and derivatives",
    },
    name2: "Multiple advantages of Hong Kong new and big stocks",
    advantage1: {
      text_1: "0 threshold of subscription",
      text_2: "No requirement on market value of the positions of the account",
      text_3:
        "You can buy new stocks as soon as you deposit advance payment for new stocks",
    },
    advantage2: {
      text_1: "Flexible subscription",
      text_2: "You can apply a stock with financing or cash",
      text_3: "Buy new Hong Kong stocks in a flexible way",
    },
    advantage3: {
      text_1: "Low interest rate for financing",
      text_2: "Subscribe with financing",
      text_3: "Annual interest rate as low as 1.88%",
      text_4: "20 times of financing leverage maximally to help buy new stocks",
    },
    advantage4: {
      text_1: "Profit making effect",
      text_2: "Deadline between January to November 3, 2021",
      text_3: "Default subscription of each new stock",
      text_4: "Cumulative ROE is about 81%",
    },
    advantage5: {
      text_1: "Dark pool transaction",
      text_2: " One trading day before the listing of new shares",
      text_3: "Buy and sell the stock in the dark pool after the closing",
    },
    advantage6: {
      text_1: "Unicorn bonus",
      text_2: "Unicorn enterprises are popular",
      text_3: "in the capital market after they are listed",
      text_4: "e.g.: Quick - earn 19,000 HKD at  W first day with one lot",
    },
    phone:
      "More questions, please contact customer service hotline: 400-688-3187",
  },
  how_to_invest:{
    title:'Why invest in Hong Kong stocks and U.S. stocks?',
    title1:'Invest the world’s top listed companies.',
    title2:'Time will highlight the value of a good company. Just like Buffett, hold and keep good companies.',
    listTitle:'Perfect system and strict supervision',
    ul:{
      li1:{
        t1:'Transparent trading market',
        t2:'Hong Kong and U.S. stock markets are well regulated, investors’ rights and interests are well protected.'
      },
      li2:{
        t1:'T+0 transaction',
        t2:'Buy and sell on the same day, which makes transactions more flexible.'
      },
      li3:{
        t1:'Abundant investment targets',
        t2:'Stocks, ETFs, funds and REITs.'
      },
      li4:{
        t1:'Convenient financing and short-selling',
        t2:'Low financing gates, short selling can be combined with derivatives'
      }
    }
  },
  account_security_old: {
    title: "About account security",
    title1: "Legal operation in line with supervisory regulations",
    title2: "Allows you to complete each deal with concern free",
    content1: {
      desc1: {
        text_1: "Licensed broker",
        text_2: "Participants of Hong Kong Exchanges and Clearing Market",
        text_3: "Licensed broker (Central code: AAW177)",
      },
      desc2: {
        text_1: "Independent trusteeship",
        text_2:
          "The customer's funds are independently deposited in Bank of China (Hong Kong)",
        text_3:
          "The customer's securities assets are deposited in the central clearing institution",
      },
      desc3: {
        text_1: "Brand experience",
        text_2: "Founded in Hong Kong China in 1989",
        text_3: "with over 32 years of industrial experience",
      },
      desc4: {
        text_1: "Data encryption",
        text_2: "Adopted advanced encryption technology at bank level",
        text_3:
          "to protect assets and information security of customers with distributed data center",
      },
      desc5: {
        text_1: "Insurance and guarantee",
        text_2:
          "Hong Kong stocks are protected by the Hong Kong Investor Compensation Fund (ICF)",
        text_3: "with 500,000 HKD",
      },
    },
    title3: "Won multiple wards of the industry",
    content3: {
      desc1: {
        text_1: "Best Internet Innovative Broker",
        text_2: "Issued by Zhitong Finance and Economy",
      },
      desc2: {
        text_1: "Outstanding Hong Kong-based Broker App",
        text_2: "issued by Securities Times and Broker China",
      },
      desc3: {
        text_1: "Innovative Mainland Market Service Information Provider",
        text_2: "issued by Hong Kong Exchanges",
      },
      desc4: {
        text_1: "Best Comprehensive Service Award",
        text_2: "issued by Finance.ifeng",
      },
    },
    phone:
      "More questions, please contact customer service hotline: 400-688-3187",
  },
  account_security:{
    title:'Safety and Security',
    title1:'Investment safety has always been our top priority',
    ul:{
      li1:{
        t1:'Licensed Broker',
        t2:'Meta Stock PTY LTD，ABN 17656191847 , is licensed and regulated by Australian Securities and Investment Commission (ASIC).',
        t3:'Metaverse Securities is a corporation licensed by the Hong Kong Securities and Futures Commission (license number: AAW177), holding business licenses No. 1/4/5/9, and is applying for licenses No. 2/6/7 in Hong Kong. The group is obtaining AFSL Licence in Australia, CMS license in Singapore and SEC Broker-Dealer in the United States.'
      },
      li2:{
        t1:'Assets will be held in escrow by the rules',
        t2:"Your assets will be kept in escrow in accordance with the custody rules. They won't be withdrawn or deposited from any third party. We will check your assets on every trading day for safety.",
        t3:"Your assets will be kept in escrow in accordance with the custody rules. They won't be withdrawn or deposited from any third party. We will check your assets on every trading day for safety."
      },
      li3:{
        t1:'Accounts will be strictly supervised',
        t2:'Your accounts will be subjected to strict supervision ,internal and external audits regularly. All our supervision complies with the requirements of local regulators.',
        t3:'Your accounts will be subjected to strict supervision ,internal and external audits regularly. All our supervision complies with the requirements of local regulators.'
      },
    }
  },
  why_choose_us_old: {
    title: "Why choose us",
    title1: "Easy account opening steps and secured transaction",
    content1: {
      desc1: {
        text_1: "Secured transaction",
        text_2: "Licensed broker under the supervision of SFC",
        text_3: "(Central code: AAW177)",
      },
      desc2: {
        text_1: "Secured funds",
        text_2:
          "Third-party independent custody of funds/assets and strict supervision guarantee",
      },
      desc3: {
        text_1: "Easy account opening steps",
        text_2:
          "2-minute speedy online account opening - invest all over the world with one account",
      },
      desc4: {
        text_1: "Smooth deposit",
        text_2:
          "Support FPS/e-DDA/bank-securities transfer and other fast deposit modes",
      },
      desc5: {
        text_1: "Attractive welfare",
        text_2:
          "Send premium stocks for free with infinite welfare after you open an account",
      },
      desc6: {
        text_1: "Considerate service",
        text_2:
          "Customer satisfaction oriented, professional consultation, and considerate service",
      },
    },
    phone:
      "More questions, please contact customer service hotline: 400-688-3187",
  },
  why_choose_us: {
    title:'Why Choose Us?',
    title_intro:'A reliable, licensed broker with good service for global investment.',
    ul:{
      li1:{
        t1:'One Account Global Investment',
        t2:'One-stop investment in Hong Kong, US stocks, Shanghai, Shenzhen Stock connect with our single integrated account.simple and fast operation make your investment more convenient and efficient.',
      },
      li2:{
        t1:'Various financial assets',
        t2:'US stocks, Hong Kong stocks, A-shares, ETF, REITs, Hong Kong stock warrants , more Than 30000 financial asset help you to build diversified global portfolio,and more financial products will be launched soon.',
      },
      li3:{
        t1:'Meta Research Institute',
        t2:'Massive research report interpretation, sharing investment research analysis and strategies to domestic and foreign investors, Special research on Metaverse help you seize scarce investment opportunities across borders.',
      },
      li4:{
        t1:'Supreme 3v1 VIP Service',
        t2:'3v1 Exclusive Service, Daily Report Before and After Trading, Metaverse Weekly, Metaverse Internal Reference, Special Direct Connection Guests, Quotes Analysis of Major Assets, Quarterly Heavyweight Salon, All together 15 Interests are included in our Service.',
      }
    },
    concat:'更多问题请联系客服'
  },
  how_the_gold_old: {
    title: "How to deposit funds",
    title1: "Three steps to deposit funds",
    content1: {
      desc1: {
        text_1: "Prepare a bank card, and choose a way to deposit",
        text_2:
          "Support FPS/e-DDA/bank-securities transfer and other deposit modes",
      },
      desc2: {
        text_1: "Remit to securities account",
        text_2: "Submit for Approval",
      },
      desc3: {
        text_1: "Check payment information",
        text_2: "Receive the funds in 5 minutes",
      },
    },
    phone1:
      'For more details, please click "Message" - "Help Center" in the app',
    phone2: "Or call 400-688-3187",
  },
  how_the_gold:{
    title:'How to deposit?',
    title1:'Easy deposit, easy withdrawal',
    title2:'3 steps to complete fund deposit',
    ul:{
      li1:{
        t1:'Check receiving bank account.',
        t2:'Open MetaStock App, check the receiving bank information according to the deposit guidelines.',
      },
      li2:{
        t1:'Transfer to the receiving account.',
        t2:'Submit the transfer information in the App for review.',
      },
      li3:{
        t1:'Check the transfer review results.',
        t2:'Get your account in as fast as 5 minutes.',
      },
    },
  },
  introduction_hk: {
    title: "Initial knowledge of Hong Kong stocks",
    title1: "Mining stock market value depressions",
    content1: {
      text_1: "Hong kong stock",
      text_2: "refers to",
      text_3: "stocks listed in Hong Kong Exchanges",
      text_4:
        ' Hong Kong stocks are more mature and reasonable than Mainland stocks, which reflect sensitively to the global market data. Usually, the stock of a same company has lower market valuation in Hong Kong, so the price is lower than that in A Shares. Therefore, Hong Kong stocks have always been known as "value depression".',
    },
    title2: "Market structure of Hong Kong stocks",
    content2: {
      text_1:
        "Listed companies in Hong Kong come from 26 different countries and regions around the world. The stock market of the Hong Kong Exchanges is divided into the main board and the GEM. The listing on the main board is much more strict than that on the GEM.",
      text_2: "Three types of stocks in Hong Kong:",
      text_3: "Blue chips, red chips and state-owned enterprises",
      text_4: "Blue chips",
      text_5:
        "These shares commonly feature with industry representativeness, high circulation, good financial condition, stable profit and fixed dividend distribution. (corresponding to HSI)",
      text_6: "Red chips",
      text_7:
        "refer to the shares of listed companies registered overseas but listed on the Hong Kong Exchanges and directly controlled or held by Chinese enterprises with more than 35% equity. (corresponding to HSCCI)",
      text_8: "State-owned enterprise shares",
      text_9:
        "refer to those state-owned enterprises in Mainland China that have been approved by the China Securities Regulatory Commission to list in Hongkong. It is known as H-share, which means that it is registered in Mainland China and listed on the Hong Kong Exchanges. (corresponding to HSCEI)",
      text_10:
        "The standard for distinguishing red chips from state-owned enterprise shares lies in the place of registration. Red chips are registered overseas, and state-owned enterprise shares are registered in the mainland.",
    },
    title3: "Introduction to Hong Kong stock index",
    content3: {
      desc1: "Hang Seng Index",
      text_1: "is usually known as",
      text_2: "benchmark index",
      text_3:
        "which is a weighted average stock price index with 50 listed stocks in Hong Kong stock market as component stocks and their circulation. It is the most influential stock price index reflecting the price fluctuation trend of Hong Kong stock market.",
      desc2: "Hang Seng China Enterprises Index",
      text_4:
        "reflects the performance of the larger H shares listed on the Hong Kong Exchanges. Unlike the Hang Seng Index, there is no limit on the number of constituent shares of the SOE index, but they must be",
      text_5:
        "H shares with the largest market value and within the constituent stocks of the Hang Seng Composite Index",
      desc3: "Red - chip index",
      text_6: "is mainly composed of",
      text_7:
        "25 red chips with large market value, active trading and representative of the industry",
      text_8:
        ". The industries mainly distribute in petrochemical industry, real estate, port transportation, automobile, science and technology and comprehensive industries.",
    },
    title4: "Difference between Hong Kong stocks and A Shares",
    content4: {
      desc1: "Transaction time is different",
      text_1:
        "The trading hours of A Shares are 9:00-11:30 a.m. and 1:00-3:00 p.m. on working days; The trading hours of Hong Kong stocks is longer than that of A Shares, morning from",
      text_2: "9:00-12:00",
      text_3: ", afternoon",
      text_4: "from 1:00-4:00",
      text_5:
        " The daily trading time of Hong Kong stocks is one and a half hours longer than that of A Shares.",
      desc2: "Transaction and settlement mechanisms are different",
      text_6:
        "A Shares is subject to T + 1 trading mechanism, that is, the shares bought on the same day can only be sold the next day. Real-time data of Hong Kong stocks",
      text_7: "T+0 trading",
      text_8:
        ", stocks bought on the same day can be sold on the same day, and there is no limit to the number of times, so the short-term profit space is greater.",
      text_9:
        "Concerning the settlement system, A Shares implements T + 1 and Hong Kong implements T + 2. In other words, if stocks are sold on Monday, the proceeds can be used to buy other stocks, but it is necessary to wait until Wednesday to withdraw cash.",
      desc3: "Transaction unit is different",
      text_10:
        "The trading units of Hong Kong stocks are also different from that of A Shares. One lot means100 shares in A Shares, while the one lot of Hong Kong stocks may be 100 shares, 500 shares, 1,000 shares or even 2,000 shares,",
      text_11: "which is decided by the listed company independently",
      desc4: "Different transaction variety",
      text_12:
        "After over a hundred years of development, Hong Kong stocks have a very rich variety in transactions. There are many derivatives that A Shares does not have at present, such as",
      text_13: "warrant, callable bull and bear contract, and inline warrant",
      text_14:
        "and other derivative tools with hedging function. In addition, Hong Kong stocks also support financing transactions, and A Shares requires 500,000 yuan to enable the financing function. At the same time, Hong Kong stocks can sell short, so there are opportunities to make money regardless of the rise or fall of the stock market.",
    },
    phone1: "More lectures will be launched soon!",
    phone2: "Or call 400-688-3187",
  },
  introduction_usa: {
    title: "Initial knowledge of U.S. stocks",
    title1: "Invest in the world's top companies",
    content1: {
      text_1: "U.S. stock",
      text_2: "refers to U.S. stock market U.S. stock market is",
      text_3: "the largest and most open market",
      text_4:
        ", where listed companies with complete system basically cover all famous and well-known brand companies and enterprises in the United States and even in the world. At present, it is mainly composed of Dow Jones Industrial Average, NASDAQ index and S&P 500 Index.",
    },
    title2: "US stock market",
    content2: {
      desc1: "New York Stock Exchange，NYSE",
      text_1: "New York Stock Exchange is",
      text_2:
        "an exchange with the first total market value of listed companies, the first number and market value of IPOs and the second trading volume",
      text_3:
        " So far, it has a history of more than 200 years, with more than 3000 listed enterprises. Its market is relatively mature and the listing requirements are relatively strict. Commercial stocks are mainly listed in NYSE, such as American Commercial Bank BAC.",
      desc2: "NASDAQ market",
      text_4: "is an invisible market based on electronic network, which is",
      text_5:
        "the securities market with most listed companies and greatest share trading volume in U.S.",
      text_6:
        " Nearly 7,000 companies have been listed for trading, and most of the companies listed here are technology stocks.",
      desc3: "American Stock Exchange, AMEX",
      text_7: "is currently the third largest stock exchange in U.S., which is",
      text_8:
        "the only exchange that can trade stocks, options and derivatives at the same time",
      text_9:
        ", also the only exchange that focuses on SMEs that are easy to be ignored and provides them with a series of services to increase their attention.",
    },
    title3: "Three major indexes of U.S. stocks",
    content3: {
      desc1: "Dow Jones Industrial Average",
      text_1:
        "Dow Jones Industrial Average is the oldest stock index in the world. The composite index is composed of",
      text_2:
        "average index of 65 constituent stocks of the three indexes of industry, transportation and public utilities",
      desc2: "NASDAQ index",
      text_3: "NASDAQ index is",
      text_4:
        "the stock price average index reflecting the changes of NASDAQ Stock Market",
      text_5: ", which basic index is 100.",
      desc3: "S&P 500 Index",
      text_6:
        "is a market capitalization weighted stock index composed of 500 companies selected from the U.S. stock market",
      text_7:
        "by the well-known rating company Standard & Poor's according to the market value and circulation",
      text_8:
        " It can reflect the value of US stocks, because its constituent stocks are more diversified.",
    },
    title4: "US equity derivatives",
    content4: {
      desc1: "Options",
      text_1: "Opinions is kind of",
      text_2: "right to choose",
      text_3: ", which refers to",
      text_33:
        "the right to buy or sell a certain quantity of a specific commodity at a specific price at a specific time in the future",
      text_4:
        " It is a financial tool based on futures, which gives the buyer (or holder) the right to buy or sell the underlying assets.",
      desc2: "ADR",
      text_5: "USA",
      text_6:
        "Depositary receipts represent holdings of shares in non-U.S. companies",
      text_7: "but investors can trade on the US stock market.",
      desc3: "ETF",
      text_8: "ETF is a kind of",
      text_9:
        " open-end stock fund that tracks market indexes and can be freely traded on a stock exchange",
      text_10:
        " We can understand ETF as a special form of mutual fund: issuers buy different stocks, combine them to form a mutual fund, and then divide them into small pieces and sell them on the stock market. They become ETF index funds that can be traded freely. You buy an ETF is equivalent to buying all the constituent stocks of the index.",
    },
    phone1: "More lectures will be launched soon!",
    phone2: "Or call 400-688-3187",
  },
  introduction_cn: {
    title: "Introduction to China Connect",
    title1: "Discover potential growth companies",
    content1: {
      text_1:
        'Shanghai-HongKong Connect and Shenzhen-Hong Kong Connect are collectively refer to "China Connect"',
      text_2:
        ', which is an interconnection mechanism. Hong Kong and international investors can trade and liquidate the listed shares of Shanghai Stock Exchange and Shenzhen Stock Exchange through the Stock Exchange of Hong Kong Limited (hereinafter referred to as "Hong Kong Exchanges") and its clearing house.',
      text_3:
        "Shanghai Stock Exchange/Shenzhen Stock Exchange have different types of listed securities, but Shanghai-Hong Kong Connect and Shenzhen-Hong Kong Connect can only trade A Shares (mainland company shares traded on China Stock Exchange) at the present stage.",
      text_4: "Shanghai-Hong Kong Connect",
      text_5:
        "has stocks including all constituent stocks of the SSE 180 Index and the SSE 380 index, as well as A Shares of the Shanghai Stock Exchange that are not included in the constituent stocks of the above index but have H shares listed and traded on the stock exchange at the same time.",
      text_6: "Shenzhen Stock Connect",
      text_7:
        "has stocks including all constituent stocks with a market value of no less than RMB 6 billion in the constituent stocks of Shenzhen Component Index and Shenzhen SME Innovation Index, as well as all A Shares listed on Shenzhen Stock Exchange with relevant H Shares listed on the stock exchange.",
    },
    title2: "Features of Northbound Transaction of China Connect",
    content2: {
      desc1: "Shanghai-Hong Kong Connect",
      text_1: "·Constituent stocks of SSE 180 Index and SSE 380 index",
      text_2: "·A Shares listed in A and H",
      text_3: "·Excluding Shanghai shares not traded in RMB",
      text_4: "·Excluding Shanghai shares subject to risk warning",
      desc2: "Shenzhen Stock Connect",
      text_5:
        "·Constituent stocks of Shenzhen Component Index and Shenzhen SME Innovation Index",
      text_6:
        "·Component stocks of Shenzhen Component Index and Shenzhen SME Innovation Index with a market value of more than 6 billion yuan",
      text_7: "·A Shares listed in A and H",
      text_8: "·Excluding Shenzhen shares not traded in RMB",
      text_9: "·Excluding Shenzhen stocks subject to risk warning",
    },
    phone1: "More lectures will be launched soon!",
    phone2: "Or call 400-688-3187",
  },
  account_manager: {
    title: "My account manager",
    txt_1: "Hello, I am your",
    txt_2: "exclusive account manager",
    txt_3:
      "{petName} {name}, please add my business WeChat account to enjoy VIP service",
    txt_4: "Scan QR code to add WeChat",
    txt_5: "© Copyright 2021 Meta Securities Co., Ltd All Rights Reserved",
    qr_txt_1: "Copied successfully",
    qr_txt_2:
      "This browser does not support the operation, please copy manually",
  },
}
